import Collapse from './components/Collapse';

export default Collapse;
